<div class="rich-text" [innerHTML]="content | sanitizeContent"></div>